import { render, staticRenderFns } from "./LocationChallenge.vue?vue&type=template&id=a5414fb8&"
import script from "./LocationChallenge.vue?vue&type=script&lang=js&"
export * from "./LocationChallenge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports